import styled from 'styled-components';
import React, { ChangeEvent } from 'react';
import baseInputStyle from './baseInputStyle';

const Input = styled.input`
  ${baseInputStyle}
`;

export default (
  props: React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >
) => {
  const onchange = (e: ChangeEvent<HTMLInputElement>) => {
    if (props.onChange) {
      let value = e.target.value;
      if (props.type === 'number' && value !== '0' && value.startsWith('0')) {
        e.target.value = value.substring(1);
        props.onChange(e);
      } else {
        props.onChange!(e);
      }
    }
  };

  return <Input {...(props as any)} onChange={onchange} />;
};
